import React, { useEffect } from "react";
import { Controller, useForm } from "react-hook-form";
import styles from "./FilterModal.module.scss";
import { useDispatch, useSelector } from "react-redux";
import { getAllPayments, setFilters } from "reducer/admin/paymentSlice";
import { amountPaymentOptions, paymentStatusOptions } from "constants/constants";
import SelectCustom from "components/common/Select/Select";
import { refundOptions, selectDropdownStyles } from "../constants";

const FilterModal = ({ onClose, search }) => {

  const formDropdownFields = [
    { label: "Payment Status", key: "paymentStatus", options: paymentStatusOptions },
    { label: "Refund", key: "refundStatus", options: refundOptions },
    { label: "Plan", key: "amount", options: amountPaymentOptions },
  ];

  const { filters } = useSelector(
    (state) => state.payments
  );


  const { register, handleSubmit, reset, resetField, setValue, watch, control } = useForm({
    defaultValues: {
      fromDate: filters.fromDate?.split("T")[0] || "",
      toDate: filters.toDate?.split("T")[0] || "",
      paymentStatus: filters.paymentStatus || null,
      refund: filters.refund || null,
      amount: filters.amount || null,
    },
  });

  const dispatch = useDispatch();

  const isFilterActive = () => {
    const values = watch();
    return values.fromDate || values.toDate || values.paymentStatus || values.refund || values.amount;
  };

  useEffect(() => {
    document.body.style.overflow = "hidden";
    return () => (document.body.style.overflow = "auto");
  }, []);

  // const onSubmit = (data) => {
  //   const { fromDate, toDate, ...rest } = data;
  //   let obj = {
  //     fromDate: fromDate ? new Date(fromDate).toISOString() : null,
  //     toDate: toDate ? new Date(toDate).toISOString() : null,
  //     ...rest,
  //   };
  //   dispatch(getAllPayments({ search, ...obj }));
  //   onClose();
  // };

  const onSubmit = (data) => {
    const payload = {
      ...data,
      fromDate: data.fromDate ? new Date(data.fromDate).toISOString() : "",
      toDate: data.toDate ? new Date(data.toDate).toISOString() : "",
    };
    dispatch(setFilters(payload));
    dispatch(getAllPayments({ pageSelected: 1, search: search, filters: payload }));
    onClose();
  };

  const fromDateValue = watch("fromDate");
  const toDateValue = watch("fromDate");

  const handleDateReset = () => {
    setValue("fromDate", "");
    setValue("toDate", "");
  };

  const resetAll = () => {
    reset({
      fromDate: "",
      toDate: "",
      paymentStatus: "",
      refund: "",
      amount: ""
    });
    dispatch(setFilters({ fromDate: "", toDate: "", paymentStatus: "", refund: "", amount: "" }));
    dispatch(getAllPayments({ pageSelected: 1, search: search, filters: {} }));
    onClose();
  };

  return (
    <div
      className={styles.overlay}
      onClick={(e) => e.target === e.currentTarget && onClose()}
    >
      <form className={styles.modal} onSubmit={handleSubmit(onSubmit)}>
        <div className={styles.dragBar} />

        <p className={styles.title}>Filter by:</p>

        {/* Date Range */}
        <div className={styles.section}>
          <div className={styles.labelRow}>
            <label>Date Range</label>
            <button
              type="button"
              onClick={handleDateReset}
            >
              Reset
            </button>
          </div>
          <div className={styles.dateRow}>
            <input
              type="date"
              {...register("fromDate")}
              max={toDateValue || undefined}
            />
            <input
              type="date"
              {...register("toDate")}
              min={fromDateValue || undefined}
            />
          </div>
        </div>

        {formDropdownFields?.map(({ label, key, options }) => (
          <div className={styles.section} key={key}>
            <div className={styles.labelRow}>
              <span>{label}</span>
              <button
                type="button"
                onClick={() => {
                  setValue(key, "");
                }}
              >
                Reset
              </button>
            </div>
            <Controller
              name={key}
              control={control}
              render={({ field }) => {
                let selectedOption;
                if (field.value) {
                  selectedOption = options.find(option => option.value === field.value);
                } else {
                  selectedOption = ""
                }
                return (
                  <SelectCustom
                    {...field}
                    options={options}
                    value={selectedOption}
                    styles={selectDropdownStyles()}
                    onChange={(selectedOption) => {
                      field.onChange(selectedOption?.value);
                    }}
                  />
                );
              }}
            />
          </div>
        ))}

        {/* Status */}
        {/* <Dropdown
          label="Status"
          name="paymentStatus"
          options={["Active", "Inactive", "Pending"]}
          register={register}
          resetField={resetField}
        /> */}

        {/* Refund */}
        {/* <Dropdown
          label="Refund"
          name="refund"
          options={["Pending", "Completed", "Failed"]}
          register={register}
          resetField={resetField}
        /> */}

        {/* Plan */}
        {/* <Dropdown
          label="Plan"
          name="amount"
          options={["$500", "$1000", "$1500"]}
          register={register}
          resetField={resetField}
        /> */}

        {/* Footer */}
        <div className={styles.footer}>
          <button
            type="button"
            className={`${styles.resetBtn} ${!isFilterActive() ? 'disabled' : ''}`}
            onClick={resetAll}
            disabled={!isFilterActive()}
          >
            Reset All
          </button>
          <button type="submit" className={`${styles.applyBtn} ${!isFilterActive() ? 'disabled' : ''}`} disabled={!isFilterActive()}>
            Apply Filters
          </button>
        </div>
      </form>
    </div>
  );
};

export default FilterModal;
